<template>
  <div v-acl:user.profiles_access
       class="PermissionProfilesView"
  >
    <PageHeader title="Uprawnienia"
                :description-in-modal="true"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <PermissionProfiles />
    </ShPageLayout>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        <img style="margin-right:10px"
             :src="require('@/assets/images/ikona-uprawnienia.png')"
        >
        Uprawnienia
      </template>
      <template #description>
        <PopupHints hint-template-name="permissions" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import PermissionProfiles from '@/components/PermissionProfiles';

export default {
  name: 'PermissionProfilesView',
  components: {
    PageHeader,
    PopupHints,
    ShPageLayout,
    ShModalWindow,
    PermissionProfiles,
  },

  mixins: [PopupHintsUtils],

  created() {
    this.mCheckInLocalStorageIfModalHasBeenAlreadyShown('permissionsModalOpen');
  },
};
</script>
